import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { AuthenticationService } from 'beyond-util';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private _authService: AuthenticationService,
    private _spinner: NgxSpinnerService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this._authService.getToken();
    if (token != null) {
      authReq = req.clone({ headers: req.headers.set('token', token) });
    }

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.status === 403) {
          if (this.router.url === '/login') {
            if (err.error && err.error.Errors && err.error.Errors[0].Value) {
              this._authService.loginError.emit(err.error.Errors[0].Value);
            }

            return;
          }
          // Unauthorize
          this.router.navigate(['login']);
          this._spinner.hide();
        }

        const error = err.error ? err.error.message : err.statusText;

        return Observable.throw(error);
      })
    );
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];



// WEBPACK FOOTER //
// ./src/app/guards/auth.interceptor.ts